import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Constraint, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editConstraint(data: Boundaries["editConstraint"]["request"]): void;
}

function useEditConstraint(constraint: Identifiable<Constraint>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditConstraintRequestPending(constraint),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditConstraintRequestSuccess(constraint),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditConstraintRequestFailure(constraint),
    ),
    editConstraint: core.editConstraint,
  };
}

export { useEditConstraint };
